import {range, changeRange} from "../helpers/column_names";
import {getAccessor} from "../math/sheet";
import {ignoreUndo} from "./undo";

export function init(view){

	const grid = view._table.$view.querySelector(".webix_ss_center");

	view.views = {
		register:function(type, render, track){
			if(!this._types[type])
				this._types[type] = { render:render, track:track };
		},
		move: function(id, x, y){
			const win = webix.$$(id);
			const old = webix.copy(this._pull[id]);
			this._pull[id].x = _correctPos(view, win, x, "x");
			this._pull[id].y = _correctPos(view, win, y, "y");
			view.callEvent("onAction", ["move-view", { row:id, newValue:webix.copy(this._pull[id]), value:old} ]);
			_showOne(view, win, this._pull[id]);
		},
		add: function(x, y, type, data, config, id){
			config = config || {};
			if(type == "chart" && !config.type) config.type = "line";

			const height =  config.height || 300;
			const width = config.width || 500;

			const win = webix.ui({ 
				id:id || "$ssheet-ui"+webix.uid(), // fixed id is for undo only
				view: "ssheet-ui",
				container:grid, master:view._table.config.id,
				width:width, height:height
			});

			win.attachEvent("onViewMoveEnd", (x, y) => {
				const state = view._table.getScrollState();
				this.move(id, x, y+state.y);
			});
			win.attachEvent("onViewResize", () => {
				const conf =  this._pull[id];
				const old = webix.copy(conf);

				conf.config.height = win.$height;
				conf.config.width = win.$width;
				view.callEvent("onAction", ["resize-view", { row:id, newValue:webix.copy(conf), value:old } ]);
			});
			win.attachEvent("onViewEdit", () => {
				const config = this._pull[id];
				const command = this._commands[config.type] || config.type;
				view.callEvent("onCommand", [{ id:command, viewid:id, config }]);
			});
			win.attachEvent("onViewRemove", () => this.remove(id));

			id = win.config.id;

			x = _correctPos(view, win, x, "x");
			y = _correctPos(view, win, y, "y");

			this._pull[id] = { x, y, type, data, config };
			this.update(id, data, config, true);
			_showOne(view, win, this._pull[id]);

			return id; 
		},
		remove: function(id){
			const old = this._pull[id];
			webix.$$(id).close();
			delete this._pull[id];

			view.callEvent("onAction", ["add-view", { row:id, newValue:null, value:old } ]);
		},
		get:function(id){
			return webix.$$(id).getBody();
		},
		update:function(id, data, config, inner){
			const old = inner ? null : webix.copy(this._pull[id]);
			const conf = this._pull[id];
			const actions = this._types[conf.type];

			data = data || config.data || [];
			config = config || {};

			delete config.data;

			const win = webix.$$(id);

			const height = config.height || 300;
			const width = config.width || 500;

			if(win.$width != width && win.$height != height){
				win.define({width, height});
				win.resize();
			}

			conf.data = data;
			conf.config = config;

			let node = this.get(id);

			data = _fromRange(view, conf);

			if(actions.render){
				const renderConfig = webix.copy(conf);

				//clear width and height for inner view resizing
				renderConfig.config.width = renderConfig.config.height = 0;

				node = actions.render(node, renderConfig, data);
				_processTables(node);
			}

			if(actions.track)
				_trackOne(view, node, actions.track, conf);

			view.callEvent("onAction", ["add-view", { row:id, newValue:webix.copy(this._pull[id]), value:old} ]);
		},
		_commands:{
			"image":"add-image-top",
			"chart":"add-chart"
		},
		_types:{},
		_pull:{}
	};

	// handle events
	view._table.attachEvent("onResize", () => _showAll(view) );
	view._table.attachEvent("onScrollY", () => _showAll(view) );
	view._table.attachEvent("onScrollX", () => _showAll(view) );

	view.attachEvent("onReset", () => _reset(view));
	view.attachEvent("onUndo", (type, row, column, value) => {
		const move = type === "move-view";
		if (move || type == "resize-view" || type === "add-view")
			_undoUI(view, move, row, value);
	});
	view.attachEvent("onAction", (action, p) => {
		if(action == "header-hide")
			_showAll(view);
		else if(action == "before-grid-change")
			_updateData(view, p.name, p.inc, p.data, p.start);
	});
	view.attachEvent("onColumnOperation", () =>  _showAll(view, true));
	view.attachEvent("onRowOperation", () => _showAll(view, true));
	view.attachEvent("onDataParse", (data) => _parse(view, data));
	view.attachEvent("onDataSerialize", (data, config) => _serialize(view, data, config));
	view.attachEvent("onCellChange", () => _trackAll(view));
	view.attachEvent("onMathRefresh", () => _trackAll(view));

	view.attachEvent("onDestruct", () => {
		for(let i in view.views._pull) webix.$$(i).destructor();
	});

	// set default views
	view.views.register("chart", (node, conf, data) => {
		const config = _genChartConfig(conf, data);
		return webix.ui(config, node);
	}, (view, data) => {
		view.clearAll();
		view.parse(data);
	});

	view.views.register("image", (node, conf, data) => {
		const config = webix.extend({ css:"webix_ssheet_bgimage", template:`<img src="${data}"/>` }, conf.config||{}, true );
		return webix.ui(config, node);
	});
}

function _parse(view, data){
	webix.delay(function(){ //[fixme] wait for dom, otherwise legend is misplaced https://tracker.webix.io/issue/WS-1318
		const views = data.views;
		if(views){
			ignoreUndo(function(){
				views.forEach(obj => view.views.add.apply(view.views, obj));
			}, view);
		}
	});
}

function _serialize(view, data, config){
	data.views = [];
	for(let i in view.views._pull){
		const conf = view.views._pull[i];
		const one = [conf.x, conf.y, conf.type, conf.data, conf.config];
		if(config && config.viewIds)
			one.push(i);
		data.views.push(one);
	}
}

let thread;
function _trackAll(view){
	clearTimeout(thread);
	thread = webix.delay(() => {
		const ui = view.views;
		for(let id in ui._pull){
			const track = ui._types[ui._pull[id].type].track;
			if(track){
				_trackOne(view, ui.get(id), track, ui._pull[id]);
			}
		}
	});
}

function _trackOne(view, node, track, conf){
	const data = _fromRange(view, conf, true);
	track(node, data);
}

function _updateData(view, name, inc, data, start){
	const views = data.views;
	for(let i = 0; i < views.length; i++){
		if(_isRange(views[i][3]))
			views[i][3] = changeRange(views[i][3], name, inc, start);
	}
} 

function _showAll(view, pos){
	for(let id in view.views._pull){
		const win = webix.$$(id);
		const conf = view.views._pull[id];
		if(pos){
			conf.x = _correctPos(view, win, conf.x, "x");
			conf.y = _correctPos(view, win, conf.y, "y");
		}
		_showOne(view, win, conf);
	}
}

function _showOne(view, win, conf){
	const state = view._table.getScrollState();

	win.show({
		x:conf.x,
		y:conf.y-state.y
	});
}

function _correctPos(view, win, v, type){
	if(!v && v !==0 )
		v = view._table.getScrollState()[type]+50;
	else{
		const size = type == "x" ? _getWidth(view)-win.$width : _getHeight(view)-win.$height;
		v = Math.min(Math.max(v, 0), size);
	}	
	return v;
}

function _reset(view){
	ignoreUndo(function(){
		for(let id in view.views._pull)
			view.views.remove(id);
	}, view);
}

function _undoUI(view, move, id, value){
	if(value){
		const {x, y, type, data, config} = value;
		if(view.views._pull[id]){
			if(move)
				view.views.move(id, x, y);
			else
				view.views.update(id, data, config);
		}
		else
			view.views.add(x, y, type, data, config, id);
	}
	else
		view.views.remove(id);
}

function _getWidth(view){
	let width = 0;
	view._table.eachColumn(function(id){
		if(id !== "rowId")
			width += this.getColumnConfig(id).width;
	});
	return width;
}

function _getHeight(view){
	let height = 0;
	view._table.data.each(function(obj){
		height += obj.$height || webix.skin.$active.rowHeight;
	});
	return height;
}

//disable datatables not to interfere with ss table events
function _processTables(node){
	const query = function(view){
		return view.name == "datatable" || view.name == "treetable";
	};
	let tables = node.queryView(query, "self");
	if(tables) tables = [tables];
	else tables = node.queryView(query, "all");
	tables.forEach((dt) => dt.disable());
}

/* chart-specific helpers */

const _defColors = [
	["#f55b50","#ff6d3f","#ffa521"],
	["#ffc927","#ffee54","#d3e153"],
	["#9acb61","#63b967", "#21a497"],
	["#21c5da","#3ea4f5","#5868bf"],
	["#7b53c0","#a943ba","#ec3b77"]
];
let _defCursor = 0;

function _getDefColor(){
	const group = _defColors[_defCursor];
	const index = Math.floor(Math.random()*group.length);
	_defCursor++;
	if(_defCursor == _defColors.length)
		_defCursor = 0;
	return group[index];
}

function _genChartConfig(conf, data){
	const config = webix.copy(conf.config);
	const type = config.type;

	const legend = { align:"center", valign:"bottom", layout:"x"};
	if(_isPie(type))
		_pieConfig(data, config, legend);
	else{
		legend.values = [];
		const series = [];	

		for(var i in data[0]){
			if(i != "data0" || !config.xAxis){ //can be xAxis value
				const color = _getDefColor();
				const s = { value:`#${i}#`};

				if(type == "radar" || type =="line" || type == "spline"){
					s.line = { color:color };
					s.item = { borderColor:color };
				}
				else
					s.color = color;
				if(type == "area" || type == "splineArea")
					s.alpha = 0.7;
				series.push(s);

				legend.values.push({text:data[0][i], color:color});
			}
		}

		if(config.xAxis)
			config.xAxis = { template:"#data0#"};
		if(config.legend)
			config.legend = legend;
		config.series = series;
	}

	return webix.extend({
		view:"chart",
		yAxis:{}
	}, config || {}, true );
}

function _isPie(type){
	return type == "pie" || type == "donut";
}

function _pieConfig(data, config, legend){
	for(var i in data[0]){
		if(config.legend){
			legend.template = `#${i}#`; //data0
			config.value = `#${i.replace("0", "1")}#`; //data1
		}
		else 
			config.value = `#${i}#`;
		break; 
	}
	if(config.legend)
		config.legend = legend;
	if(config.pieInnerText)
		config.pieInnerText = config.value;
}

function _isRange(data){
	return typeof data == "string" && data.indexOf("data:image") === -1;
}

function _fromRange(view, conf, parse){
	let data = conf.data;
	const coords = _isRange(data) ? range(data, view) : null;
	if(coords){
		const page = getAccessor(view, coords[4]);
		data = page ? page.getRangeCols.apply(page, coords) : [];
	}
	const config = conf.config;
	if(webix.isArray(data) && parse && config && config.legend && !_isPie(config.type))
		data.shift();
	
	return data;
}